import axios from '@/http/axios';

export default {
  fetchList: (config: any = {}) => {
    return axios.get(`/business-credit-levels`, config);
  },
};
